import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils';
import { type YJSChangeHandler } from '../../types';

export const setValueCommentThread: YJSChangeHandler<
  DatabaseChangeType.SET_VALUE_COMMENT_THREAD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.setCommentThread(getValueId(change.entryId, change.fieldId), change.newThread);
  });
};
